/* @flow */
// typecheck: ignore file
import React from 'react';
import Box from 'components/Box.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import ParentalConsentCardView from 'user/components/ParentalConsentCardView.jsx';
import ParentalConsentSignatureView from 'user/components/ParentalConsentSignatureView.jsx';

class ParentalConsentOptionView extends React.Component {
  props: {
    childId: number,
    option: string,
    onProceed: Function,
    setOption: Function,
  };

  static propTypes = {
    childId: React.PropTypes.number.isRequired,
    option: React.PropTypes.string.isRequired,
    onProceed: React.PropTypes.func.isRequired,
    setOption: React.PropTypes.func.isRequired,
  };

  handleChooseDifferentOption = () => {
    this.props.setOption('');
  };

  renderView = () => {
    const { childId, onProceed, option } = this.props;

    if (option === 'card') {
      return (
        <ParentalConsentCardView
          childId={childId}
          onProceed={onProceed}
        />
      );
    } else {
      return (
        <ParentalConsentSignatureView
          childId={childId}
          onProceed={onProceed}
        />
      );
    }
  };

  render() {
    const { option } = this.props;
    let differentOptionText;

    if (option === 'card') {
      differentOptionText = 'Prefer to print and sign a permission form?';
    } else if (option === 'signature-file') {
      differentOptionText = 'Prefer to charge a card?';
    }

    return (
      <div className="ParentalConsentOptionView">
        <Container size="small">
          <Box>
            {this.renderView()}
            <BoxFooter>
              <Button full level="text" onClick={() => this.handleChooseDifferentOption()}>
                {differentOptionText}
                {' '}
                Go back
              </Button>
            </BoxFooter>
          </Box>
        </Container>
      </div>
    );
  }
}

export default ParentalConsentOptionView;



// WEBPACK FOOTER //
// ./src/user/components/ParentalConsentOptionView.jsx